import createHistory from 'history/createBrowserHistory';
import { History } from 'history';

import { EntityType } from '../models/EntityType';
import { assertTrue } from "./utils/assert";

// Declare the relative path for each entity type
const entityRoutes = {
  [EntityType.Access]: '/access',
  [EntityType.Division]: '/division',
  [EntityType.Person]: '/person',
  [EntityType.Sensor]: '/sensor',
  [EntityType.ServiceAccount]: '/service-account',
  [EntityType.Vehicle]: '/vehicle',
  [EntityType.Dashboard]: '/dashboard',
  [EntityType.Report]: '/reports',
  [EntityType.Alarm]: '/alarms'
};

export const routeFor = (entityType: EntityType) => entityRoutes[entityType];
export const addNewRouteFor= (entityType: EntityType) => routeFor(entityType) + '/addNew';
export const editRouteFor= (entityType: EntityType) => routeFor(entityType) + '/edit';

export const homeRoute = '/dashboard';
export const alarmRoute = '/alarms'
export const assignPersonRoute = '/alarms/assign';
export const sensorsDataRoute = '/sensors-data';
export const vehicleGeoposition = '/vehicles-map';
export const settingsRoute = '/settings';

export const vehicleGroupActionsRoute = '/vehicle/group-actions';

export const sensorsReadingsRoute = (refId: string): string => {
  assertTrue(typeof refId === 'string' && refId !== '');
  return `/action/SensorsReadingsExcel?id_ref=${refId}`
};

// AppNavigator helps to navigate into different parts of our application.
// When you need to show specific tab just call AppNavigator's methods.
class AppNavigator
{
  readonly history: History;
  constructor(private basename: string)
  {
    this.history = createHistory({ basename });
  }

  goToDashboard = () => this.history.push(homeRoute);
  goToAlarm = () => this.history.push(alarmRoute);
  
  goToEntityTab = (entityType: EntityType) => this.history.push(routeFor(entityType));
  goToDivisionTab = () => this.goToEntityTab(EntityType.Division);
  goToPersonTab = () => this.goToEntityTab(EntityType.Person);
  goToServiceAccountTab = () => this.goToEntityTab(EntityType.ServiceAccount);
  goToVehicleTab = () => this.goToEntityTab(EntityType.Vehicle);
  goToSensorTab = () => this.goToEntityTab(EntityType.Sensor);

  goToAddNewEntityTab = (entityType: EntityType) => this.history.push(addNewRouteFor(entityType));
  goToEditEntityTab = (entityType: EntityType) => this.history.push(editRouteFor(entityType));

  goToSensorsDataPage = () => this.history.push(sensorsDataRoute);
  goToVehicleGeopositionPage = () => this.history.push(vehicleGeoposition);
  goToAssignPersonOnIssuePage = () => this.history.push(assignPersonRoute);
  goToSettingsPage = () => this.history.push(settingsRoute);
  goToVehicleGroupActionsPage = () => this.history.push(vehicleGroupActionsRoute);
  closeSettings = () => (this.history.length > 0) ? this.history.goBack() : this.history.replace(this.basename);
}

declare var __APP_BASE_URL__: string;
export const appNavigator = new AppNavigator(__APP_BASE_URL__);


// WEBPACK FOOTER //
// ./src/app/routes.ts